import { CoCotizaciondetalle } from './CoCotizaciondetalle';

export class CoCotizacionPk {
    companiasocio: string;
    numerodocumento: string;
}
export class CoCotizacion {
    pk: CoCotizacionPk;
    constructor() {
        this.pk = new CoCotizacionPk();
        this.coCotizaciondetalle = [];
    }
    coCotizaciondetalle: CoCotizaciondetalle[];

    fechadocumento: Date;
    fechavencimiento: Date;
    clientenumero: number;
    clienteruc: string;
    clientenombre: string;
    clientedireccion: string;
    criteria: string;
    monedadocumento: string;
    montoafecto: number;
    montonoafecto: number;
    montodescuentos: number;
    montoimpuestoventas: number;
    montototal: number;
    montocostoestimado: number;
    vendedor: number;
    comentarios: string;
    preparadopor: number;
    aprobadopor: number;
    fechapreparacion: Date;
    fechaaprobacion: Date;
    estado: string;
    ultimousuario: string;
    ultimafechamodif: Date;
    oferta: string;
    condicion: string;
    atratar: number;
    entrega: string;
    tentrega: string;
    oficina: string;
    sucursal: string;
    porcentajepercepcion: number;
    montopercepcion: number;
    vobocomercialflag: string;
    diasestimados: number;
    tiempoentrega: number;
    formadepago: string;
    lugarentrega: string;
    formafacturacion: string;
    tipoventa: string;
    unidadnegocio: string;
    tipofacturacion: string;
    almacencodigo: string;
    idtipodecisionanalisis: number;
    vobo4todctoflag: string;
    autorizacionempleado: number;
    autorizacionpassword: number;
    item: string;
    tipodecambio: number;
    tipodocumento: string;
    cantidad: number;
    margenVenta: number;
    montoAfecto: number;
    montoNoAfecto: number;
    montoTotal: number;
    iv_action: string;
    sumatoriaTotal: number;
    sumatoriaCostoTotal: number;
    totalconIGV: string;
    verDescuento4: string;
    // AUXILIARES
    linea: number;
    descuento01: number;
    descuento02: number;
    descuento03: number;
    descuento04: number;
    cantidadItem: number;
    claveAutorizacion: number;
    descuento04flag: string;
    auxFechaDocumento: string;
    montoTotalDetalle: number;
    montoMargenDetalle: number;
    tipoVendedor:string;

}
